import React from "react";
import { Card, Row, Col, Button, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../branchTransactionOutwardSlice";
import { SearchOutlined } from "@ant-design/icons";
import { fetchBranchTransactionOutward } from "../branchTransactionOutwardThunk";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";

const BranchTransactionOutwardFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.branchTransactionOutward);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleSubmit = () => {
    dispatch(fetchBranchTransactionOutward({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch report ❌");
      }
    });
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={16} style={{ alignItems: "center" }}>
        {/* Status */}
        <Col xs={24} sm={12} md={6} lg={4}>
          <label>Status</label>
          <SearchListAutoComplete
            // value={filters.status}
            onSelect={(obj) => {
              if(!obj) {
                handleFilterChange("status", null);
                return;
              } 
              handleFilterChange("status", obj?.sale_id);
            }}
            optionsList={[
              { sale_id: "p", display_text: "Pending" },
              { sale_id: "a", display_text: "Active" },
            ]}
            placeholder="Status"
            showAddNew={false}
          />
        </Col>

        {/* Submit */}
        <Col
          xs={24}
          sm={12}
          md={6}
          lg={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSubmit}
            block
            style ={{height: 35.19}}
            data-testid="report-btn"
          >
            Get Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default BranchTransactionOutwardFilters;
